module.exports = __webpack_public_path__ + "media/newstyle/images/background-service-all-73f4f2677aef7ebabd4c6bf74b78e575.png";